import { __assign, __read, __spreadArray } from "tslib";
export function isSubschemaConfig(value) {
    return Boolean(value === null || value === void 0 ? void 0 : value.schema);
}
export function cloneSubschemaConfig(subschemaConfig) {
    var newSubschemaConfig = __assign(__assign({}, subschemaConfig), { transforms: subschemaConfig.transforms != null ? __spreadArray([], __read(subschemaConfig.transforms)) : undefined });
    if (newSubschemaConfig.merge != null) {
        newSubschemaConfig.merge = __assign({}, subschemaConfig.merge);
        Object.keys(newSubschemaConfig.merge).forEach(function (typeName) {
            newSubschemaConfig.merge[typeName] = __assign({}, subschemaConfig.merge[typeName]);
            var fields = newSubschemaConfig.merge[typeName].fields;
            if (fields != null) {
                Object.keys(fields).forEach(function (fieldName) {
                    fields[fieldName] = __assign({}, fields[fieldName]);
                });
            }
        });
    }
    return newSubschemaConfig;
}
//# sourceMappingURL=subschemaConfig.js.map